import React, { useState } from "react";
import { Button, Box } from "common";
import { Checkbox, MenuItem } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { setPromotionObject } from "store/actions/promotion.actions";
import { IPaymentMethods } from "store/reducers/paymentMethods.reducers";
import { ExclusionLabel } from "store/reducers/promotion.reducers";
import { useStyles } from "../Restrictions.style";

const PaymentOptions = ({
  options,
  isMenuOpen,
  menuOpenHandler,
  name,
  getValue,
}: {
  options: IPaymentMethods[];
  isMenuOpen: boolean;
  menuOpenHandler: any;
  name: string;
  getValue: (keys: string[]) => string | Date;
}) => {
  const { dropdownBox } = useStyles();

  const values = (getValue(["restrictions", name]) as any)?.value || [];
  const [selected, setSelected] = useState(values || []);
  const dispatch = useDispatch();

  const isSelected = (value: string) =>
    selected.some((val: string) => val === value);

  const handleChange = (value: string) => {
    const alreadySelected = selected.find((val: string) => val === value);
    if (alreadySelected) {
      setSelected((prev: string[]) =>
        prev.filter((val: string) => val !== value)
      );
    } else {
      setSelected((prev: string[]) => [...prev, value]);
    }
  };

  const clearState = () => {
    setSelected([]);
    dispatch(setPromotionObject("", ["restrictions", name]));
  };
  
  const applyFilters = () => {
    menuOpenHandler(!isMenuOpen);
    if (selected.length > 0) {
      const paymentRules = {
        op: ExclusionLabel.notIn,
        value: selected,
      };
      dispatch(setPromotionObject(paymentRules, ["restrictions", name]));
    }
  };

  return (
    <Box display={isMenuOpen ? "" : "none"} className={dropdownBox}>
      {options.map((paymentMethod: IPaymentMethods) => {
        return (
          <MenuItem key={paymentMethod.label}>
            <Checkbox
              data-testid={`payment-multi-checkbox-${paymentMethod.value}`}
              checked={isSelected(paymentMethod.value)}
              onChange={() => handleChange(paymentMethod.value)}
              name={paymentMethod.label}
              color="primary"
            />
            {paymentMethod.label}
          </MenuItem>
        );
      })}
      <Box display={"flex"} alignItems="center" justifyContent={"flex-end"}>
        <Button
          round
          variant="outlined"
          color="primary"
          margin="10px"
          onClick={clearState}
        >
          Clear
        </Button>
        <Button
          round
          variant="contained"
          color="secondary"
          margin="10px"
          onClick={applyFilters}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentOptions;
